import { render, staticRenderFns } from "./Ebookprew.vue?vue&type=template&id=2af11e53&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2Fxhtml&"
import script from "./Ebookprew.vue?vue&type=script&lang=js&"
export * from "./Ebookprew.vue?vue&type=script&lang=js&"
import style0 from "./Ebookprew.vue?vue&type=style&index=0&id=2af11e53&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af11e53",
  null
  
)

export default component.exports